<template>
    <div>
        <div class="d-flex justify-content-between">
            <img class="image" src="img/svg/thank-you.svg">
        </div>
        <h2 align="center" class="mt-3">Awesome</h2>
        <p class="font-weight-bold text-center">You have successfully Created your account</p>
        <b-row class="mt-3">
            <b-col md="12">
                <b-button class="btn btn-block" btn-color="primary" @click="e=>$emit('done')">Done</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
  name: "ThankYou"
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #007bff;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #007bff;
  color: white;
}
</style>
